import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as tutorialSelectors from '../../tutorial.selectors'
import * as tutorialActions from '../../tutorial.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import VoteQuestion from '../../../Mars/Quizzes/VoteQuestion/VoteQuestion'

const mapDispatchToProps = (dispatch) => ({
  clearResponses: () => 'CLEAR_RESPONSES',
  changeMiningScreen: bindActionCreators(tutorialActions.changeMiningScreen, dispatch),
  voteQuestion: bindActionCreators(tutorialActions.voteQuestion, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

const mapStateToProps = (state) => ({
  currentQuestion: tutorialSelectors.getVoteQuestion(state),
  error: {},
  playerList: {},
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VoteQuestion))
